import { render, staticRenderFns } from "./styleOfProceedingsActions.vue?vue&type=template&id=69ae8559&scoped=true"
import script from "./styleOfProceedingsActions.vue?vue&type=script&lang=ts"
export * from "./styleOfProceedingsActions.vue?vue&type=script&lang=ts"
import style0 from "./styleOfProceedingsActions.vue?vue&type=style&index=0&id=69ae8559&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ae8559",
  null
  
)

export default component.exports